import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import { getLang } from '../utils/helpers';
import './VueTipTapEditor.scss';
/**
 * [F-ONBUI3] A composer-chipek (<%prefix.field%>) címkéinek beültetése a Vue bundle által figyelt
 * window-globálba + a 'tiptap_composer_codes_loaded' esemény (a már kirenderelt chipek frissülnek).
 */
export function seedComposerCodes(map) {
    window.tiptap_composer_codes = map;
    window.tiptap_composer_codes_loading = false;
    window.dispatchEvent(new CustomEvent('tiptap_composer_codes_loaded'));
}
// ---------------------------------------------------------------------------
// AppTranslation - required by the Vue TipTap bundle (legacy global)
// ---------------------------------------------------------------------------
const TIPTAP_TRANSLATIONS = {
    hu: {
        'tiptap-urleditor-url': 'Link URL címe',
        'tiptap-urleditor-video-url': 'Video URL címe',
        'tiptap-urleditor-text': 'Link szövege',
        'tiptap-urleditor-deleteurl': 'link törlése',
        'tiptap-characters': 'karakter',
        'tiptap-words': 'szó',
        'tiptap-sms': 'SMS',
        'tiptap-width': 'Szél.',
        'tiptap-height': 'Mag.',
        'tiptap-keep-ratio': 'Rögzített képarány',
        'tiptap-apply': 'Mentés',
        'williampopup-modify': 'Átfogalmazás',
        'williampopup-summarize': 'Összefoglalás',
        'williampopup-more': 'Bővebb szöveggé alakítás',
        'williampopup-less': 'Kevesebb szöveggé alakítás',
        'williampopup-synonim': 'Szinoníma keresése',
        'williampopup-bullet': 'Felsorolás készítése',
        'williampopup-explain': 'Magyarázat írása',
        'williampopup-own': 'Saját parancs készítése',
        'williampopup-translate': 'Fordítás',
        'williampopup-copy': 'Eredmény vágólapra másolás',
        'williampopup-copy-selected': 'Eredményből kijelölt vágólapra másolása',
        'williampopup-replace': 'Eredetiben felülírás eredménnyel',
        'williampopup-replace-selected': 'Eredetiben felülírás kijelöléssel',
        'williampopup-retry': 'Teljes újragenerálás',
        'williampopup-placeholder': 'Add meg Williamnek a szerkesztési utasítást...',
        'williampopup-placeholder-modify': 'Hogyan módosítson William rajta?',
        'williampopup-loading-1': 'Gondolkodás...',
        'williampopup-loading-2': 'Szövegmátrix szintetizálása...',
        'williampopup-loading-3': 'Tartalomgenerálás...',
        'williampopup-loading-4': 'Szövegoptimalizálás...',
        // [CU-869f45km6] William chat (a szerkesztő beépített William-ablaka) feliratai -
        // e nélkül a bundle angol fallback-szövegei jelentek meg magyar felületen
        'william-chat-placeholder': 'Írj Williamnek...',
        'william-chat-content-updated': 'Tartalom frissítve',
        'william-chat-error': 'Hiba történt, próbáld újra.',
        'william-chat-pin': 'Kitűzés',
        'william-chat-unpin': 'Kitűzés feloldása',
        'language-hu': 'Magyar',
        'language-en': 'Angol',
        'language-de': 'Német',
        'language-sk': 'Szlovák',
        'language-cs': 'Cseh',
        'language-ro': 'Román',
        'language-uk': 'Ukrán',
        'language-ru': 'Orosz',
        'language-hr': 'Horvát',
        'language-sr': 'Szerb',
    },
    en: {
        'tiptap-urleditor-url': 'Link URL',
        'tiptap-urleditor-video-url': 'Video URL',
        'tiptap-urleditor-text': 'Link text',
        'tiptap-urleditor-deleteurl': 'delete link',
        'tiptap-characters': 'characters',
        'tiptap-words': 'words',
        'tiptap-sms': 'SMS',
        'tiptap-width': 'Width',
        'tiptap-height': 'Height',
        'tiptap-keep-ratio': 'Fixed ratio',
        'tiptap-apply': 'Save',
        'williampopup-modify': 'Rephrase',
        'williampopup-summarize': 'Summarize',
        'williampopup-more': 'Expand text',
        'williampopup-less': 'Shorten text',
        'williampopup-synonim': 'Find synonyms',
        'williampopup-bullet': 'Create bullet points',
        'williampopup-explain': 'Write an explanation',
        'williampopup-own': 'Write own prompt',
        'williampopup-translate': 'Translate',
        'williampopup-copy': 'Copy result to clipboard',
        'williampopup-copy-selected': 'Selection from result to clipboard',
        'williampopup-replace': 'Replace in original',
        'williampopup-replace-selected': 'Replace with selected in original',
        'williampopup-retry': 'Full regenerate',
        'williampopup-placeholder': 'Give William the editing instruction...',
        'williampopup-placeholder-modify': 'How should William modify it?',
        'williampopup-loading-1': 'Thinking...',
        'williampopup-loading-2': 'Synthesizing text matrix...',
        'williampopup-loading-3': 'Generating content...',
        'williampopup-loading-4': 'Optimizing text...',
        'william-chat-placeholder': 'Write to William...',
        'william-chat-content-updated': 'Content updated',
        'william-chat-error': 'An error occurred, please try again.',
        'william-chat-pin': 'Pin',
        'william-chat-unpin': 'Unpin',
        'language-hu': 'Hungarian',
        'language-en': 'English',
        'language-de': 'German',
        'language-sk': 'Slovak',
        'language-cs': 'Czech',
        'language-ro': 'Romanian',
        'language-uk': 'Ukrainian',
        'language-ru': 'Russian',
        'language-hr': 'Croatian',
        'language-sr': 'Serbian',
    },
};
function getTipTapTranslations() {
    // Use the miniapp's current language (set via setLang() from backend)
    const lang = getLang();
    return TIPTAP_TRANSLATIONS[lang] || TIPTAP_TRANSLATIONS.hu;
}
// ---------------------------------------------------------------------------
// Script loader - ensures the Vue TipTap bundle is loaded exactly once
// ---------------------------------------------------------------------------
const BUNDLE_URL = '/js/vue/tiptapeditor/bundle.js';
let loadPromise = null;
function loadTipTapBundle() {
    // Already available on window - no need to load
    if (typeof window.vue_tiptap_init === 'function') {
        return Promise.resolve();
    }
    // Already loading - return existing promise
    if (loadPromise) {
        return loadPromise;
    }
    // [F-EMOJIPICK] A közös EmojiPicker mag előre tárolt konfigurációja — a bundle
    // betöltése ELŐTT kell léteznie (a mag inicializáláskor olvassa fel): katalógus-URL
    // + cache-busting verzió a frame bundle-URL-jeiből, nyelv a dokumentumból.
    if (!window.EmojiPickerConfig) {
        const coreScript = document.querySelector('script[src*="react-core.bundle.js"]');
        const versionMatch = coreScript && coreScript.src ? coreScript.src.match(/[?&]v=([^&]+)/) : null;
        window.EmojiPickerConfig = {
            catalogUrl: '/js/data/emoji-catalog.json',
            version: versionMatch ? versionMatch[1] : '',
            locale: (document.documentElement.lang || 'hu').slice(0, 2),
        };
    }
    // Set AppTranslation global BEFORE loading the bundle
    if (!window.AppTranslation) {
        window.AppTranslation = getTipTapTranslations();
    }
    loadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = BUNDLE_URL;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            loadPromise = null; // allow retry
            reject(new Error('Failed to load TipTap editor bundle'));
        };
        document.head.appendChild(script);
    });
    return loadPromise;
}
// ---------------------------------------------------------------------------
// Component ID counter
// ---------------------------------------------------------------------------
let idCounter = 0;
/** [CU-869f4uky1] a William hibaüzenete a bundle nyelvi kulcsából (a miniapp seedeli az AppTranslation-t) */
const williamErrorText = () => {
    const tr = window.AppTranslation;
    return (tr && tr['william-chat-error']) || 'Hiba történt, próbáld újra.';
};
/** Sima szöveg → TipTap JSON-dokumentum (egy bekezdés, egy text node; üresnél üres bekezdés). */
const textToDoc = (text) => ({
    type: 'doc',
    content: [{ type: 'paragraph', content: text ? [{ type: 'text', text }] : [] }],
});
const DEFAULT_WIDGETS = [
    'bold',
    'italic',
    'underline',
    'link',
    'bulletlist',
    'orderedlist',
    'insertimage',
    'emoji',
];
// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------
export const VueTipTapEditor = forwardRef(function VueTipTapEditor({ value, onChange, placeholder = '', disabled = false, height = '120px', widgets = DEFAULT_WIDGETS, borderless = false, commentMode = false, limitEnabled = false, limit = 65535, onWilliam, onWilliamChat, onEnter, mentions, onWidget, composerCodes, singleLine = false, uploadModule, uploadAction, }, ref) {
    // Stable component ID that persists across renders
    const componentIdRef = useRef('vue-tiptap-' + ++idCounter);
    const componentId = componentIdRef.current;
    // Refs for the outer container and internal state
    const containerRef = useRef(null);
    const vmRef = useRef(null);
    const lastHtmlRef = useRef(value);
    const initializedRef = useRef(false);
    // Stable refs for callbacks so the event listener always has latest values
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;
    const onWilliamRef = useRef(onWilliam);
    onWilliamRef.current = onWilliam;
    const onWilliamChatRef = useRef(onWilliamChat);
    onWilliamChatRef.current = onWilliamChat;
    const onEnterRef = useRef(onEnter);
    onEnterRef.current = onEnter;
    const onWidgetRef = useRef(onWidget);
    onWidgetRef.current = onWidget;
    // [F-ONBUI2 Codex CR] forrásnézetben a textarea tartalma csak váltáskor kerül az editorba: beszúrás
    // és kiolvasás előtt vissza kell váltani, különben a beszúrás a régi forrással felülíródna
    const leaveSourceView = (vm) => {
        if (vm.isHtmlView && typeof vm.toggleEditorView === 'function') {
            vm.toggleEditorView();
        }
    };
    // [F-ONBUI2] imperatív API: beszúrás + HTML kiolvasás forrásnézet-szinkronnal
    useImperativeHandle(ref, () => ({
        insertComposerTag: (code) => {
            const vm = vmRef.current;
            if (!vm)
                return;
            leaveSourceView(vm);
            if (typeof vm.insertComposerTag === 'function') {
                vm.insertComposerTag(code);
            }
            else {
                vm.editor.commands.insertContent('<%' + code + '%>');
            }
        },
        insertContent: (html) => {
            const vm = vmRef.current;
            if (!vm)
                return;
            leaveSourceView(vm);
            vm.editor.commands.insertContent(html);
        },
        getHTML: () => {
            const vm = vmRef.current;
            if (!vm)
                return lastHtmlRef.current;
            leaveSourceView(vm);
            const html = vm.editor.getHTML();
            lastHtmlRef.current = html;
            return html;
        },
        setValue: (next) => {
            const vm = vmRef.current;
            lastHtmlRef.current = next;
            if (!vm)
                return;
            try {
                vm.editor.commands.setContent(singleLine ? textToDoc(next) : next);
            }
            catch {
                // átmeneti állapot
            }
        },
    }), []);
    // -------------------------------------------------------------------
    // Custom event handler (tiptap_customevent)
    // -------------------------------------------------------------------
    const handleCustomEvent = useCallback((event) => {
        const detail = event.detail;
        if (!detail || detail.componentId !== componentId)
            return;
        const { message, params } = detail;
        switch (message) {
            case 'update': {
                const vm = vmRef.current;
                if (!vm)
                    return;
                const html = singleLine ? vm.editor.getText({ blockSeparator: ' ' }) : vm.editor.getHTML();
                // Only fire onChange when the HTML actually changed (prevents loops)
                if (html !== lastHtmlRef.current) {
                    lastHtmlRef.current = html;
                    onChangeRef.current(html);
                }
                break;
            }
            case 'william-prompt': {
                const handler = onWilliamRef.current;
                if (!handler || !params)
                    return;
                const text = params.selectedText || params.text || '';
                const func = params.func || '';
                // [CU-869f4uky1] hibánál (null / kivétel) is le kell zárni a töltést: az
                // író-modal a hibaüzenetet kapja tartalomként, nem marad örök spinner
                const failPrompt = () => {
                    if (window.tiptap_instances?.[componentId]) {
                        window.tiptap_instances[componentId].processWilliamRequest({
                            content: williamErrorText(),
                            func: func,
                        });
                    }
                };
                handler(text, func, params)
                    .then((result) => {
                    if (result == null) {
                        failPrompt();
                        return;
                    }
                    if (window.tiptap_instances?.[componentId]) {
                        window.tiptap_instances[componentId].processWilliamRequest({
                            content: result,
                            func: func,
                        });
                    }
                })
                    .catch(failPrompt);
                break;
            }
            case 'william-chat-send': {
                // [CU-869f4uky1] a chat-stílusú William overlay (WilliamChat.vue) NEM a
                // 'william-prompt'-ot, hanem ezt az eseményt küldi - eddig a miniappban
                // senki nem válaszolt rá, ezért a "..." töltő örökre a képernyőn maradt.
                const vm = window.tiptap_instances?.[componentId];
                if (!vm)
                    return;
                const chatFail = () => {
                    if (vm.$refs && vm.$refs.williamChat) {
                        vm.$refs.williamChat.addErrorMessage();
                    }
                };
                const p = (params || {});
                const chatParams = {
                    query: p.query || '',
                    editorContent: p.editorContent || '',
                    selectedHtml: p.selectedHtml || null,
                    selectionMode: !!p.selectionMode,
                    conversation_id: p.conversation_id || null,
                    promptFunc: p.promptFunc || null,
                };
                const chatHandler = onWilliamChatRef.current;
                if (chatHandler) {
                    chatHandler(chatParams)
                        .then((result) => {
                        if (!result || typeof vm.processWilliamChatResponse !== 'function') {
                            chatFail();
                            return;
                        }
                        vm.processWilliamChatResponse(result);
                    })
                        .catch(chatFail);
                    break;
                }
                // visszaesés: a régi popup-út (szerkesztő-tartalom/kijelölés + gyors-akció kulcs)
                const legacyHandler = onWilliamRef.current;
                const source = chatParams.selectionMode && chatParams.selectedHtml ? chatParams.selectedHtml : chatParams.editorContent;
                if (!legacyHandler || !source) {
                    chatFail();
                    break;
                }
                legacyHandler(source, chatParams.promptFunc || 'williampopup-modify', { prompt: chatParams.query })
                    .then((result) => {
                    if (result == null || typeof vm.processWilliamChatResponse !== 'function') {
                        chatFail();
                        return;
                    }
                    vm.processWilliamChatResponse({ answer: chatParams.query, editor_content: result });
                })
                    .catch(chatFail);
                break;
            }
            case 'key_enter': {
                const enterHandler = onEnterRef.current;
                if (enterHandler) {
                    enterHandler();
                }
                break;
            }
            case 'william-clipboard': {
                // The Vue editor handles clipboard UI internally - nothing needed here
                break;
            }
            case 'codeinjector':
            case 'sabloninjector': {
                // [F-ONBUI2] a hoszt saját (React) választót nyit; nincs legacy modal
                const widgetHandler = onWidgetRef.current;
                if (widgetHandler) {
                    widgetHandler(message, params);
                }
                break;
            }
            default:
                break;
        }
    }, [componentId, singleLine]);
    // -------------------------------------------------------------------
    // Mount / unmount the Vue editor
    // -------------------------------------------------------------------
    // [F-ONBUI3] chip-címkék: az init ELŐTT és minden prop-változáskor (a chipek az eventre frissülnek)
    useEffect(() => {
        if (composerCodes) {
            seedComposerCodes(composerCodes);
        }
    }, [composerCodes]);
    useEffect(() => {
        let destroyed = false;
        const initEditor = async () => {
            console.log('[VueTipTap] Starting init, componentId:', componentId);
            try {
                await loadTipTapBundle();
                console.log('[VueTipTap] Bundle loaded, vue_tiptap_init:', typeof window.vue_tiptap_init);
            }
            catch (err) {
                console.error('[VueTipTap] Bundle load FAILED:', err);
                return;
            }
            if (destroyed || !containerRef.current) {
                console.log('[VueTipTap] Aborted: destroyed=', destroyed, 'container=', !!containerRef.current);
                return;
            }
            if (typeof window.vue_tiptap_init !== 'function') {
                console.error('[VueTipTap] vue_tiptap_init is NOT a function after bundle load!');
                return;
            }
            // Set mentions for @mention feature
            if (mentions) {
                window.availableUsers = mentions;
            }
            // Inject initial content into the .ui-tiptap element before Vue mounts
            const inner = containerRef.current.querySelector('.ui-tiptap');
            if (inner && !singleLine) {
                inner.innerHTML = value;
            }
            lastHtmlRef.current = value;
            // Add event listener BEFORE init so we catch the initial 'update' if any
            window.addEventListener('tiptap_customevent', handleCustomEvent);
            const selector = `[data-component-id='${componentId}'] .ui-tiptap`;
            const element = document.querySelector(selector);
            console.log('[VueTipTap] DOM selector:', selector, 'found:', !!element);
            try {
                const vm = window.vue_tiptap_init({
                    componentId,
                    widgets,
                    height,
                    limit,
                    htmlmode: true,
                    limitenabled: limitEnabled,
                    placeholder,
                    isbuttonstoggle: false,
                    iscommentmode: commentMode,
                    singleline: singleLine,
                    uploadmodule: uploadModule || '',
                    uploadaction: uploadAction || '',
                });
                console.log('[VueTipTap] Init SUCCESS, vm:', !!vm, 'editor:', !!vm?.editor);
                if (!destroyed) {
                    vmRef.current = vm;
                    initializedRef.current = true;
                    // [F-ONBUI5] egysoros mód: a kezdő érték JSON-doc úton (a setContent nem emittál update-et)
                    if (singleLine) {
                        try {
                            vm.editor.commands.setContent(textToDoc(value));
                        }
                        catch {
                            // átmeneti állapot - a value-szinkron effekt pótolja
                        }
                    }
                    // Apply disabled state after init
                    if (disabled) {
                        try {
                            vm.editor.setEditable(false);
                        }
                        catch {
                            // setEditable may not be available on all versions
                        }
                    }
                }
            }
            catch (err) {
                console.error('[VueTipTap] Init FAILED:', err);
            }
        };
        initEditor();
        return () => {
            destroyed = true;
            window.removeEventListener('tiptap_customevent', handleCustomEvent);
            if (initializedRef.current) {
                try {
                    if (typeof window.vue_tiptap_destruct === 'function') {
                        window.vue_tiptap_destruct(componentId);
                    }
                }
                catch {
                    // Ignore cleanup errors
                }
                vmRef.current = null;
                initializedRef.current = false;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Intentionally empty deps: we mount/unmount the Vue editor exactly once.
    // Props are read through refs so they don't need to be deps.
    // -------------------------------------------------------------------
    // Sync value prop -> Vue editor (only when value changes externally)
    // -------------------------------------------------------------------
    useEffect(() => {
        const vm = vmRef.current;
        if (!vm || !initializedRef.current)
            return;
        // Only push to editor when the value differs from the last editor output
        if (value !== lastHtmlRef.current) {
            lastHtmlRef.current = value;
            try {
                vm.editor.commands.setContent(singleLine ? textToDoc(value) : value);
            }
            catch {
                // Editor may be in a transitional state
            }
        }
    }, [value]);
    // -------------------------------------------------------------------
    // Sync disabled prop -> editor editable state
    // -------------------------------------------------------------------
    useEffect(() => {
        const vm = vmRef.current;
        if (!vm || !initializedRef.current)
            return;
        try {
            vm.editor.setEditable(!disabled);
        }
        catch {
            // setEditable may not be available
        }
    }, [disabled]);
    // -------------------------------------------------------------------
    // Sync mentions prop -> window.availableUsers
    // -------------------------------------------------------------------
    useEffect(() => {
        if (mentions) {
            window.availableUsers = mentions;
        }
    }, [mentions]);
    // -------------------------------------------------------------------
    // Render
    //
    // CRITICAL: React only manages the outer wrapper. The inner .ui-tiptap
    // div is taken over by Vue after mount. React must NOT re-render it.
    // Using dangerouslySetInnerHTML={__html: ''} ensures React treats the
    // inner div as opaque and will not attempt to reconcile its children.
    // -------------------------------------------------------------------
    return (_jsx("div", { className: `vue-tiptap-wrapper${borderless ? ' vue-tiptap-borderless' : ''}`, ref: containerRef, "data-component-id": componentId, children: _jsx("div", { className: "ui-tiptap", dangerouslySetInnerHTML: { __html: '' } }) }));
});
